import React, { useState, useEffect } from "react";
import { Row, Col, Form, Container, FormGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { GetReceivingByDatePDFApi, SearchReceivingWithDateApi } from "./Receiving.action";
import { setHeading } from "../../../accounts/account.actions";
import moment from "moment";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";


const ReceivingReportWithDate = (props) => {
    const [startDate, setStartDate] = useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

    const PrintPDF = () => {
        props.GetReceivingByDatePDFApi({
            startDate: !isEmpty(startDate) ? startDate : "",
            endDate: !isEmpty(endDate) ? endDate : "",
        },
            startDate,
            endDate,
        )
        setStartDate(moment().subtract(30, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
    }

    const SearchReceiving = () => {
        props.SearchReceivingWithDateApi({
            startDate: !isEmpty(startDate) ? startDate : "",
            endDate: !isEmpty(endDate) ? endDate : "",
        },
            startDate,
            endDate,
        )
        setStartDate(moment().subtract(30, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
    }

    useEffect(() => {
        props.setHeading("Receiving Report");
    }, []);

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <FormGroup>
                            <Form.Label><b>Start Date *</b></Form.Label>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            >
                            </Form.Control>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Form.Label><b>End Date *</b></Form.Label>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            >
                            </Form.Control>
                        </FormGroup>
                    </Col>
                </Row>

                <div className="sendDiv">
                    {/* <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => SearchReceiving()}> SEARCH </Button> */}
                    <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => PrintPDF()}> PRINT PDF </Button>
                </div>

            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        GetReceivingByDatePDFApi: (data, startDate, endDate) => dispatch(GetReceivingByDatePDFApi(data, startDate, endDate)),
        SearchReceivingWithDateApi: (data, startDate, endDate) => dispatch(SearchReceivingWithDateApi(data, startDate, endDate)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};

const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ReceivingReportWithDate);